<template>
  <div class="procedures-editor-info">
    <divider orientation="left">Сведения о запросе материалов</divider>
    <div v-if="object === 'expertise'" class="procedures-editor-info__block">
      <row :gutter="16">
        <i-col span="12">
          <span class="ms-help label">Тип заключения</span>
          <i-select
            size="default"
            placeholder="Тип запроса"
            v-model="procedure.expertise_type_id"
            :disabled="!getCommonModulePerms('procedure', 'update')"
          >
            <i-option
              v-for="type in procedureTypes"
              :value="type.id"
              :key="type.id"
            >
              {{ type.name }}
            </i-option>
          </i-select>
        </i-col>
      </row>
    </div>
    <div class="procedures-editor-info__block">
      <row :gutter="16">
        <i-col span="12">
          <span class="ms-help label">Статус</span>
          <i-select
            size="default"
            placeholder="Статус запроса"
            v-model="procedure[statusField]"
            :disabled="!getCommonModulePerms('procedure', 'update')"
          >
            <i-option
              v-for="status in procedureStatuses"
              :value="status.id"
              :key="status.id"
            >
              {{ status.name }}
            </i-option>
          </i-select>
        </i-col>
      </row>
    </div>
    <!-- <div class="procedures-editor-info__block">
      <row :gutter="16">
        <i-col span="12">
          <span class="ms-help label">
            Планируемая дата создания
          </span>
          <date-picker
            placeholder="Выберите дату"
            format="dd.MM.yyyy"
            v-model="procedure.creation_date"
            :disabled="!getCommonModulePerms('procedure', 'update')"
          />
        </i-col>
        <i-col span="12">
          <span class="ms-help label">
            Фактическая дата создания
          </span>
          <date-picker
            :class="getErrorClass(procedure.receive_date)"
            placeholder="Выберите дату"
            format="dd.MM.yyyy"
            v-model="procedure.receive_date"
            :disabled="!getCommonModulePerms('procedure', 'update')"
          />
        </i-col>
      </row>
      <row :gutter="16">
        <i-col span="12">
          <span class="ms-help label">
            Планируемая дата получения
          </span>
          <date-picker
            placeholder="Выберите дату"
            format="dd.MM.yyyy"
            v-model="procedure.creation_date"
            :disabled="!getCommonModulePerms('procedure', 'update')"
          />
        </i-col>
        <i-col span="12">
          <span class="ms-help label">
            Фактическая дата получения
          </span>
          <date-picker
            :class="getErrorClass(procedure.receive_date)"
            placeholder="Выберите дату"
            format="dd.MM.yyyy"
            v-model="procedure.receive_date"
            :disabled="!getCommonModulePerms('procedure', 'update')"
          />
        </i-col>
      </row>
    </div> -->
    <div class="procedures-editor-info__block">
      <row :gutter="16">
        <i-col span="24">
          <span class="ms-help label">
            Реквизит итогового документа
          </span>
          <i-input
            v-model="procedure.description"
            type="textarea"
            placeholder="Дополнительная информация о запросе материалов"
            :disabled="!getCommonModulePerms('procedure', 'update')"
          />
        </i-col>
      </row>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: ['procedure', 'procedure-statuses', 'procedure-types', 'object'],
  computed: {
    statusField () {
      return `${this.object}_status_id`
    }
  },
  methods: {
    getErrorClass (date) {
      if (!date) return ''
      const { procedure, procedureStatuses } = this
      const { procedure_status_id, creation_date } = procedure
      const status = procedureStatuses.find(s => s.id === procedure_status_id)
      if (status && status.name !== 'Отправлен запрос') return ''

      const unix = moment(date).unix()

      return unix < moment(creation_date).unix() ? 'error' : ''
    }
  }
}
</script>

<style lang="less">
.procedures-editor-info {
  &__block {
    margin-bottom: 8px;
  }

  .ivu-date-picker {
    width: 100%;

    &.error {
      .ivu-input {
        border: 1px solid @danger-color !important;
      }
    }
  }
}
</style>
